<script lang="ts">
  import type { StyleValue } from 'vue'
  import { defineComponent, computed } from 'vue'
  import { getNamespace } from '../../../utils/global-config'
  import { addUnit } from '../../../shared/utils'

  export default defineComponent({
    name: 'BnIconAppEnterprise',
    props: {
      size: {
        type: [Number, String],
        default: undefined
      },
      rotate: {
        type: Number,
        default: undefined
      },
      spin: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: undefined
      }
    },
    setup(props) {
      const ns = getNamespace('icon')

      const styles = computed(() => {
        const styles: StyleValue = {}
        if (props.size) {
          styles.fontSize = addUnit(props.size)
        }

        if (props.rotate) {
          styles.transform = `rotate(${props.rotate}deg)`
        }

        if (props.color) {
          styles.color = props.color
        }
        return styles
      })

      const cls = computed(() => [
        ns,
        {
          [`${ns}-loading`]: props.spin
        }
      ])

      return {
        cls,
        styles
      }
    }
  })
</script>

<template>
  <i :class="cls" :style="styles">
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>编组 16</title>
      <g id="抓潜拓客" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="菜单图标" transform="translate(-200.000000, -280.000000)" fill="#9CA6B9">
          <g id="编组-16" transform="translate(200.000000, 280.000000)">
            <path
              id="矩形"
              d="M14.8795868,5.17191386 C14.9592489,5.39098444 15,5.62229495 15,5.85539998 L15,20 C15,20.5522847 14.5522847,21 14,21 L5,21 C4.44771525,21 4,20.5522847 4,20 L4,8.40085453 C4,7.55984165 4.5261355,6.808678 5.31651387,6.52126768 L12.3165139,3.97581314 C13.354581,3.59833417 14.5021079,4.13384671 14.8795868,5.17191386 Z M13.3759174,5.71870276 C13.3098586,5.53704101 13.1258861,5.43233293 12.9418404,5.45957066 L12.8633028,5.47948261 L5.86330277,8.02493716 C5.73157305,8.07283888 5.63654372,8.18515078 5.60852643,8.31859694 L5.6,8.40085453 L5.6,19.4 L13.4,19.4 L13.4,5.85539998 C13.4,5.83208948 13.3979624,5.8088687 13.3939333,5.78599879 L13.3759174,5.71870276 Z"
              fill-rule="nonzero"
            ></path>
            <path
              id="路径-10"
              d="M14.495944,7.29275252 L19.3716356,9.87037886 C20.0749876,10.2422192 20.5325603,10.9486655 20.590444,11.7342562 L20.5966739,11.9037154 L20.5966739,19.704503 C20.5966739,20.3776 20.0851242,20.9312183 19.4295913,20.9977912 L19.2966739,21.004503 L13.1183129,21.004503 L13.1183129,19.404503 L18.996,19.404 L18.9966739,11.9037154 C18.9966739,11.6813445 18.8912572,11.474605 18.7167054,11.3437177 L18.6238361,11.2848738 L13.7481446,8.70724748 L14.495944,7.29275252 Z"
              fill-rule="nonzero"
            ></path>
            <rect id="矩形" x="8" y="11" width="3" height="1.6"></rect>
            <rect id="矩形" x="8" y="15" width="3" height="1.6"></rect>
          </g>
        </g>
      </g>
    </svg>
  </i>
</template>
